import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ApiPageResponse, PageQuery } from '../types/api.types';
import {
  PaymentMethod,
  PaymentMethodWriteRequest,
} from '../types/payment-method.types';

@Injectable({ providedIn: 'root' })
export class PaymentMethodsService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/payment/api/payment-methods`;

  /** Admin paginated list. Envelope: `{data, totalItems, totalPages}` (no
   *  status/message — payment-service doesn't wrap via ResponseHandler). */
  list(query: PageQuery = {}): Observable<ApiPageResponse<PaymentMethod>> {
    return this.http.get<ApiPageResponse<PaymentMethod>>(
      `${this.base}/all`,
      { params: this.pageParams(query) },
    );
  }

  /** Public-facing list of active methods (no pagination, no admin). */
  listActive(): Observable<PaymentMethod[]> {
    return this.http.get<PaymentMethod[]>(this.base);
  }

  get(id: number): Observable<PaymentMethod> {
    return this.http.get<PaymentMethod>(`${this.base}/${id}`);
  }

  create(payload: PaymentMethodWriteRequest): Observable<PaymentMethod> {
    return this.http.post<PaymentMethod>(this.base, payload);
  }

  /** Note: the back uses PUT (full replace), not PATCH. */
  update(id: number, payload: PaymentMethodWriteRequest): Observable<PaymentMethod> {
    return this.http.put<PaymentMethod>(`${this.base}/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  /** Bascule actif/inactif — `PUT /payment/api/payment-methods/change-status/{id}`.
   *  Renvoie la méthode mise à jour (le back toggle le flag `status`). */
  changeStatus(id: number): Observable<PaymentMethod> {
    return this.http.put<PaymentMethod>(`${this.base}/change-status/${id}`, {});
  }

  private pageParams(query: PageQuery): HttpParams {
    let params = new HttpParams()
      .set('pageable', 'true')
      .set('page', String(query.page ?? 1))
      .set('size', String(query.size ?? 10))
      .set('isDeleted', String(query.isDeleted ?? false));
    if (query.search?.trim()) params = params.set('search', query.search.trim());
    return params;
  }
}
